/**
 * Supabase Client for Frontend
 */
import { createClient } from '@supabase/supabase-js'
import { capacitorStorage } from '../services/capacitorStorage'
import { config } from '../config'
import { recoveryRedirectHref } from './authRecovery'

/**
 * If a recovery link landed on Site URL (/), do not let the client consume
 * the hash before we move the user to /reset-password.
 */
function shouldDetectSessionInUrl (): boolean {
  if (typeof window === 'undefined') return true
  return recoveryRedirectHref(
    window.location.pathname,
    window.location.hash,
    window.location.search
  ) === null
}

export const supabase = createClient(config.supabase.url, config.supabase.anonKey, {
  auth: {
    storage: capacitorStorage,
    detectSessionInUrl: shouldDetectSessionInUrl(),
  }
})

export const API_URL = config.apiUrl
